import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import {
  Link,
  LinkIcon
} from '../'
import Styles from './SolutionsList.css'

@CSSModules(Styles,{allowMultiple:true})
export default class SolutionsList extends Component {
  render() {
    const icon1 = require( '../../../static/images/123-1.png' )
    const icon2 = require( '../../../static/images/123-2.png' )
    const titles = {
      0: 'Employees need access to sustainable investing',
      1: 'Sustainability should be the standard',
    }
    const descriptions = {
      0: 'If a retirement plan doesn’t offer sustainable options, employees are being forced to assume the financial risks of unsustainable investing, often without understanding the long-term impacts. ',
      1: 'Making the default investment option sustainable is the best way to protect everyone from the financial risks of unsustainable investments.',
    }
    return (
      <nav styleName='solutions-list'>
        {
          [
            [config.routes.solutionOfferSustainability, icon1],
            [config.routes.solutionDefaultSustainability, icon2],
          ].map((e, i) => {
            const [url, icon] = e
            const title = titles[i] || 'Lorem'
            const description = descriptions[i] || 'Lorem'
            return (
              <div>
                <button
                  styleName='data-link'
                  key={'data-link-'+i}
                >
                  <Link
                    to={url}
                    title={title}
                  >
                    <div styleName='data-link-in'>
                      <img
                        src={icon}
                        alt={title}
                      />
                      <div>
                        <h2>
                          {title}
                        </h2>
                        <p>
                          {description}
                        </p>
                        <p>Learn more<LinkIcon/></p>
                      </div>
                    </div>
                  </Link>
                </button>
                <hr/>
              </div>
            )
          })
        }
      </nav>
    )
  }
}